import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from './components/Navbar';
import FilterSidebar from './components/FilterSidebar';
import VehicleGrid from './components/VehicleGrid';
import Footer from '../home/components/Footer';

export interface Vehicle {
  id: number;
  name: string;
  year: number;
  make: string;
  model: string;
  price: number;
  mileage: number;
  location: string;
  badge?: string;
  transmission: string;
  fuelType: string;
  bodyType: string;
  color: string;
  images: string[];
}

const allVehicles: Vehicle[] = [
  {
    id: 1,
    name: '2016 Honda Pilot EX',
    year: 2016,
    make: 'Honda',
    model: 'Pilot',
    price: 12995,
    mileage: 138000,
    location: 'Fayetteville, GA',
    badge: 'Luxury',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'White',
    images: [
      'https://public.readdy.ai/ai/img_res/15a12fb47aff80e01f9f939f7ad2541f.jpg'
    ]
  },
  {
    id: 37,
    name: '2016 Infiniti QX80',
    year: 2016,
    make: 'Infiniti',
    model: 'QX80',
    price: 19995,
    mileage: 109000,
    location: 'Fayetteville, GA',
    badge: 'Premium',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=luxurious%20silver%202016%20Infiniti%20QX80%20full%20size%20premium%20SUV%20with%20elegant%20silver%20metallic%20exterior%20and%20sophisticated%20black%20leather%20interior%20displayed%20in%20professional%20automotive%20studio%20with%20pristine%20white%20background%20and%20dramatic%20lighting%20showcasing%20commanding%20presence%20bold%20grille%20design%20and%20refined%20luxury%20styling&width=800&height=600&seq=inf2silver&orientation=landscape'
    ]
  },
  {
    id: 42,
    name: '2017 Infiniti QX60',
    year: 2017,
    make: 'Infiniti',
    model: 'QX60',
    price: 12995,
    mileage: 128000,
    location: 'Fayetteville, GA',
    badge: 'Premium Interior',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'Blue',
    images: [
      'https://readdy.ai/api/search-image?query=stunning%20deep%20blue%20metallic%202017%20Infiniti%20QX60%20luxury%20crossover%20SUV%20with%20elegant%20blue%20exterior%20paint%20and%20sophisticated%20beige%20leather%20interior%20displayed%20in%20professional%20automotive%20studio%20with%20pristine%20white%20background%20and%20dramatic%20lighting%20showcasing%20premium%20craftsmanship%20refined%20styling%20and%20luxurious%20appointments&width=800&height=600&seq=inf42blue&orientation=landscape',
      'https://readdy.ai/api/search-image?query=luxurious%20beige%20leather%20interior%20of%202017%20Infiniti%20QX60%20showing%20premium%20seats%20elegant%20dashboard%20wood%20trim%20and%20sophisticated%20cabin%20design%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20highlighting%20comfort%20and%20refinement&width=800&height=600&seq=inf42int&orientation=landscape',
      'https://readdy.ai/api/search-image?query=side%20profile%20view%20of%20deep%20blue%202017%20Infiniti%20QX60%20highlighting%20sleek%20body%20lines%20elegant%20proportions%20and%20premium%20alloy%20wheels%20in%20professional%20automotive%20studio%20with%20clean%20white%20background&width=800&height=600&seq=inf42side&orientation=landscape',
      'https://readdy.ai/api/search-image?query=rear%20three%20quarter%20view%20of%20blue%202017%20Infiniti%20QX60%20showing%20LED%20taillights%20and%20sophisticated%20rear%20design%20in%20professional%20automotive%20photography%20with%20pristine%20white%20background&width=800&height=600&seq=inf42rear&orientation=landscape'
    ]
  },
  {
    id: 43,
    name: '2017 Nissan Altima S',
    year: 2017,
    make: 'Nissan',
    model: 'Altima',
    price: 13495,
    mileage: 92000,
    location: 'Fayetteville, GA',
    badge: 'Clean Interior',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=sleek%20silver%20metallic%202017%20Nissan%20Altima%20S%20sedan%20with%20elegant%20silver%20exterior%20paint%20and%20dark%20gray%20cloth%20interior%20displayed%20in%20professional%20automotive%20studio%20with%20pristine%20white%20background%20and%20sophisticated%20lighting%20showcasing%20modern%20aerodynamic%20design%20refined%20styling%20and%20comfortable%20cabin%20appointments&width=800&height=600&seq=nis43silver&orientation=landscape',
      'https://readdy.ai/api/search-image?query=clean%20dark%20gray%20cloth%20interior%20of%202017%20Nissan%20Altima%20S%20showing%20comfortable%20front%20seats%20modern%20dashboard%20touchscreen%20display%20and%20well%20maintained%20cabin%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20highlighting%20practicality%20and%20comfort&width=800&height=600&seq=nis43int&orientation=landscape',
      'https://readdy.ai/api/search-image?query=side%20profile%20view%20of%20silver%202017%20Nissan%20Altima%20S%20highlighting%20sleek%20body%20lines%20elegant%20proportions%20and%20stylish%20alloy%20wheels%20in%20professional%20automotive%20studio%20with%20clean%20white%20background&width=800&height=600&seq=nis43side&orientation=landscape'
    ]
  },
  {
    id: 6,
    name: '2015 Dodge Grand Caravan SE',
    year: 2015,
    make: 'Dodge',
    model: 'Grand Caravan',
    price: 11995,
    mileage: 112000,
    location: 'Fayetteville, GA',
    badge: 'Family Van',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Van',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=practical%20silver%202015%20Dodge%20Grand%20Caravan%20SE%20minivan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20spacious%20family%20friendly%20design&width=800&height=600&seq=dod1&orientation=landscape'
    ]
  },
  {
    id: 7,
    name: '2018 Infiniti QX60',
    year: 2018,
    make: 'Infiniti',
    model: 'QX60',
    price: 11995,
    mileage: 128000,
    location: 'Fayetteville, GA',
    badge: 'Popular',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'White',
    images: [
      'https://readdy.ai/api/search-image?query=reliable%20white%202018%20Infiniti%20QX60%20SUV%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20versatile%20design%20and%20family%20friendly%20features&width=800&height=600&seq=inf1a&orientation=landscape'
    ]
  },
  {
    id: 8,
    name: '2017 Hyundai Elantra Limited',
    year: 2017,
    make: 'Hyundai',
    model: 'Elantra',
    price: 12995,
    mileage: 144455,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Black',
    images: [
      'https://readdy.ai/api/search-image?query=elegant%20black%202017%20Hyundai%20Elantra%20Limited%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20refined%20styling%20and%20premium%20interior&width=800&height=600&seq=hyun1&orientation=landscape'
    ]
  },
  {
    id: 9,
    name: '2014 Toyota Camry Hybrid LE',
    year: 2014,
    make: 'Toyota',
    model: 'Camry',
    price: 13995,
    mileage: 105000,
    location: 'Fayetteville, GA',
    badge: 'Hybrid',
    transmission: 'CVT',
    fuelType: 'Hybrid',
    bodyType: 'Sedan',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=efficient%20silver%202014%20Toyota%20Camry%20Hybrid%20LE%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20eco%20friendly%20technology%20and%20reliable%20performance&width=800&height=600&seq=toy1&orientation=landscape'
    ]
  },
  {
    id: 10,
    name: '2015 Toyota RAV4',
    year: 2015,
    make: 'Toyota',
    model: 'RAV4',
    price: 16995,
    mileage: 92000,
    location: 'Fayetteville, GA',
    badge: 'Best Seller',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'Blue',
    images: [
      'https://readdy.ai/api/search-image?query=dependable%20blue%202015%20Toyota%20RAV4%20compact%20SUV%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20versatile%20design%20and%20practical%20features&width=800&height=600&seq=toy2&orientation=landscape'
    ]
  },
  {
    id: 11,
    name: '2018 Toyota Camry',
    year: 2018,
    make: 'Toyota',
    model: 'Camry',
    price: 18995,
    mileage: 68000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Blue',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20blue%202018%20Toyota%20Camry%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20sleek%20contemporary%20design%20and%20advanced%20features&width=800&height=600&seq=toy3&orientation=landscape'
    ]
  },
  {
    id: 12,
    name: '2020 Toyota Camry SE',
    year: 2020,
    make: 'Toyota',
    model: 'Camry',
    price: 22995,
    mileage: 45000,
    location: 'Fayetteville, GA',
    badge: 'Low Miles',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'White',
    images: [
      'https://readdy.ai/api/search-image?query=sporty%20white%202020%20Toyota%20Camry%20SE%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20athletic%20design%20and%20premium%20features&width=800&height=600&seq=toy4&orientation=landscape'
    ]
  },
  {
    id: 13,
    name: '2021 Toyota Camry LE',
    year: 2021,
    make: 'Toyota',
    model: 'Camry',
    price: 24995,
    mileage: 32000,
    location: 'Fayetteville, GA',
    badge: 'Like New',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=pristine%20silver%202021%20Toyota%20Camry%20LE%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20modern%20elegant%20design%20and%20advanced%20technology&width=800&height=600&seq=toy5&orientation=landscape'
    ]
  },
  {
    id: 14,
    name: '2021 Toyota Camry',
    year: 2021,
    make: 'Toyota',
    model: 'Camry',
    price: 25995,
    mileage: 28000,
    location: 'Fayetteville, GA',
    badge: 'Certified',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Gray',
    images: [
      'https://readdy.ai/api/search-image?query=sophisticated%20gray%202021%20Toyota%20Camry%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20refined%20styling%20and%20premium%20quality&width=800&height=600&seq=toy6&orientation=landscape'
    ]
  },
  {
    id: 15,
    name: '2017 Chevrolet Malibu LS',
    year: 2017,
    make: 'Chevrolet',
    model: 'Malibu',
    price: 13995,
    mileage: 88000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'White',
    images: [
      'https://readdy.ai/api/search-image?query=clean%20white%202017%20Chevrolet%20Malibu%20LS%20sedan%20in%20professional%20automotive%20studio%20with%20pristine%20white%20background%20highlighting%20practical%20design%20and%20comfortable%20interior&width=800&height=600&seq=chev2&orientation=landscape'
    ]
  },
  {
    id: 16,
    name: '2017 Hyundai Elantra SE',
    year: 2017,
    make: 'Hyundai',
    model: 'Elantra',
    price: 11995,
    mileage: 108998,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=efficient%20silver%202017%20Hyundai%20Elantra%20SE%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20modern%20design%20and%20fuel%20efficiency&width=800&height=600&seq=hyun2&orientation=landscape'
    ]
  },
  {
    id: 17,
    name: '2015 Nissan Altima S',
    year: 2015,
    make: 'Nissan',
    model: 'Altima',
    price: 11995,
    mileage: 118000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'White',
    images: [
      'https://readdy.ai/api/search-image?query=reliable%20white%202015%20Nissan%20Altima%20S%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20dependable%20performance%20and%20comfortable%20ride&width=800&height=600&seq=nis2&orientation=landscape'
    ]
  },
  {
    id: 19,
    name: '2013 Nissan Sentra S',
    year: 2013,
    make: 'Nissan',
    model: 'Sentra',
    price: 8995,
    mileage: 125000,
    location: 'Fayetteville, GA',
    badge: 'Budget Friendly',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Gray',
    images: [
      'https://readdy.ai/api/search-image?query=affordable%20gray%202013%20Nissan%20Sentra%20S%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20economical%20transportation%20and%20reliable%20performance&width=800&height=600&seq=nis4&orientation=landscape'
    ]
  },
  {
    id: 20,
    name: '2015 Nissan Sentra SR',
    year: 2015,
    make: 'Nissan',
    model: 'Sentra',
    price: 10995,
    mileage: 108035,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Gray',
    images: [
      'https://readdy.ai/api/search-image?query=sporty%20gray%202015%20Nissan%20Sentra%20SR%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20athletic%20styling%20and%20enhanced%20features&width=800&height=600&seq=nis5&orientation=landscape'
    ]
  },
  {
    id: 21,
    name: '2003 Dodge Grand Caravan Sport',
    year: 2003,
    make: 'Dodge',
    model: 'Grand Caravan',
    price: 4995,
    mileage: 107781,
    location: 'Fayetteville, GA',
    badge: 'As-Is',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Van',
    color: 'Black',
    images: [
      'https://readdy.ai/api/search-image?query=classic%20black%202003%20Dodge%20Grand%20Caravan%20Sport%20minivan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20spacious%20family%20vehicle%20design&width=800&height=600&seq=dod2&orientation=landscape'
    ]
  },
  {
    id: 22,
    name: '2013 Dodge Avenger SE',
    year: 2013,
    make: 'Dodge',
    model: 'Avenger',
    price: 9995,
    mileage: 115000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=sleek%20silver%202013%20Dodge%20Avenger%20SE%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20bold%20styling%20and%20comfortable%20interior&width=800&height=600&seq=dod3&orientation=landscape'
    ]
  },
  {
    id: 23,
    name: '2009 Dodge Journey SXT',
    year: 2009,
    make: 'Dodge',
    model: 'Journey',
    price: 7995,
    mileage: 135000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'Blue',
    images: [
      'https://readdy.ai/api/search-image?query=versatile%20blue%202009%20Dodge%20Journey%20SXT%20crossover%20SUV%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20practical%20family%20vehicle%20design&width=800&height=600&seq=dod4&orientation=landscape'
    ]
  },
  {
    id: 24,
    name: '2001 Dodge Ram 2500',
    year: 2001,
    make: 'Dodge',
    model: 'Ram 2500',
    price: 8995,
    mileage: 185000,
    location: 'Fayetteville, GA',
    badge: 'Work Truck',
    transmission: 'Automatic',
    fuelType: 'Diesel',
    bodyType: 'Truck',
    color: 'White',
    images: [
      'https://readdy.ai/api/search-image?query=rugged%20white%202001%20Dodge%20Ram%202500%20heavy%20duty%20pickup%20truck%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20powerful%20work%20truck%20capability&width=800&height=600&seq=dod5&orientation=landscape'
    ]
  },
  {
    id: 25,
    name: '2008 Chevrolet Equinox LS',
    year: 2008,
    make: 'Chevrolet',
    model: 'Equinox',
    price: 7995,
    mileage: 142000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'Green',
    images: [
      'https://readdy.ai/api/search-image?query=practical%20green%202008%20Chevrolet%20Equinox%20LS%20compact%20SUV%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20versatile%20crossover%20design&width=800&height=600&seq=chev3&orientation=landscape'
    ]
  },
  {
    id: 26,
    name: '2010 Jeep Patriot Sport',
    year: 2010,
    make: 'Jeep',
    model: 'Patriot',
    price: 8995,
    mileage: 135000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'Red',
    images: [
      'https://readdy.ai/api/search-image?query=adventurous%20red%202010%20Jeep%20Patriot%20Sport%20compact%20SUV%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20rugged%20off%20road%20capable%20design&width=800&height=600&seq=jeep1&orientation=landscape'
    ]
  },
  {
    id: 27,
    name: '2015 Nissan Sentra SL',
    year: 2015,
    make: 'Nissan',
    model: 'Sentra',
    price: 11995,
    mileage: 98000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Gold',
    images: [
      'https://readdy.ai/api/search-image?query=elegant%20gold%202015%20Nissan%20Sentra%20SL%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20premium%20trim%20level%20and%20refined%20features&width=800&height=600&seq=nis6&orientation=landscape'
    ]
  },
  {
    id: 28,
    name: '2014 Toyota Camry',
    year: 2014,
    make: 'Toyota',
    model: 'Camry',
    price: 13995,
    mileage: 141000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=dependable%20silver%202014%20Toyota%20Camry%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20reliable%20performance%20and%20comfortable%20ride&width=800&height=600&seq=toy7&orientation=landscape'
    ]
  },
  {
    id: 29,
    name: '2008 Dodge Avenger SXT',
    year: 2008,
    make: 'Dodge',
    model: 'Avenger',
    price: 6995,
    mileage: 148000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Blue',
    images: [
      'https://readdy.ai/api/search-image?query=affordable%20blue%202008%20Dodge%20Avenger%20SXT%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20practical%20transportation%20option&width=800&height=600&seq=dod6&orientation=landscape'
    ]
  },
  {
    id: 30,
    name: '2008 Dodge Avenger SXT',
    year: 2008,
    make: 'Dodge',
    model: 'Avenger',
    price: 6995,
    mileage: 152000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Blue',
    images: [
      'https://readdy.ai/api/search-image?query=economical%20blue%202008%20Dodge%20Avenger%20SXT%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20budget%20friendly%20sedan%20option&width=800&height=600&seq=dod7&orientation=landscape'
    ]
  },
  {
    id: 31,
    name: '2013 Dodge Avenger',
    year: 2013,
    make: 'Dodge',
    model: 'Avenger',
    price: 9995,
    mileage: 122000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Red',
    images: [
      'https://readdy.ai/api/search-image?query=vibrant%20red%202013%20Dodge%20Avenger%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20sporty%20styling%20and%20modern%20features&width=800&height=600&seq=dod8&orientation=landscape'
    ]
  },
  {
    id: 32,
    name: '2011 Mazda CX-7 Sport',
    year: 2011,
    make: 'Mazda',
    model: 'CX-7',
    price: 10995,
    mileage: 115000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'Black',
    images: [
      'https://readdy.ai/api/search-image?query=sporty%20black%202011%20Mazda%20CX7%20Sport%20crossover%20SUV%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20dynamic%20design%20and%20performance%20oriented%20features&width=800&height=600&seq=maz1&orientation=landscape'
    ]
  },
  {
    id: 33,
    name: '2011 Hyundai Elantra GLS',
    year: 2011,
    make: 'Hyundai',
    model: 'Elantra',
    price: 8995,
    mileage: 128000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Silver',
    images: [
      'https://readdy.ai/api/search-image?query=efficient%20silver%202011%20Hyundai%20Elantra%20GLS%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20fuel%20efficient%20design%20and%20comfortable%20interior&width=800&height=600&seq=hyun3&orientation=landscape'
    ]
  },
  {
    id: 34,
    name: '2007 Toyota Camry LE',
    year: 2007,
    make: 'Toyota',
    model: 'Camry',
    price: 7995,
    mileage: 165000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'Gold',
    images: [
      'https://readdy.ai/api/search-image?query=reliable%20gold%202007%20Toyota%20Camry%20LE%20sedan%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20legendary%20Toyota%20reliability%20and%20durability&width=800&height=600&seq=toy8&orientation=landscape'
    ]
  },
  {
    id: 35,
    name: '2012 Hyundai Sonata GLS',
    year: 2012,
    make: 'Hyundai',
    model: 'Sonata',
    price: 9995,
    mileage: 135000,
    location: 'Fayetteville, GA',
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    bodyType: 'Sedan',
    color: 'White',
    images: [
      'https://readdy.ai/api/search-image?query=elegant%20white%202012%20Hyundai%20Sonata%20GLS%20sedan%20in%20professional%20automotive%20studio%20with%20clean%20white%20background%20highlighting%20sophisticated%20design%20and%20spacious%20interior&width=800&height=600&seq=hyun4&orientation=landscape'
    ]
  },
  {
    id: 36,
    name: '2014 Nissan Rogue Select',
    year: 2014,
    make: 'Nissan',
    model: 'Rogue',
    price: 11995,
    mileage: 130000,
    location: 'Fayetteville, GA',
    transmission: 'CVT',
    fuelType: 'Gasoline',
    bodyType: 'SUV',
    color: 'Gray',
    images: [
      'https://readdy.ai/api/search-image?query=versatile%20gray%202014%20Nissan%20Rogue%20Select%20compact%20SUV%20in%20professional%20automotive%20photography%20with%20clean%20white%20background%20showcasing%20practical%20crossover%20design%20and%20fuel%20efficiency&width=800&height=600&seq=nis7&orientation=landscape'
    ]
  }
];

/* -------------------------------------------------
   IndexedDB Helper Functions
------------------------------------------------- */
const DB_NAME = 'CarInventoryDB';
const DB_VERSION = 1;
const STORE_NAME = 'carImages';

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

async function loadFromIndexedDB(key: string): Promise<any> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readonly');
    const store = transaction.objectStore(STORE_NAME);
    const request = store.get(key);
    
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export default function InventoryPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [vehicles, setVehicles] = useState<Vehicle[]>(allVehicles);
  const [filteredVehicles, setFilteredVehicles] = useState<Vehicle[]>(allVehicles);
  const [selectedForCompare, setSelectedForCompare] = useState<number[]>([]);
  const [sortBy, setSortBy] = useState('featured');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  const [filters, setFilters] = useState({
    priceRange: [0, 50000],
    mileageRange: [0, 150000],
    yearRange: [2015, 2024],
    makes: [] as string[],
    models: [] as string[],
    bodyTypes: [] as string[],
    transmissions: [] as string[],
    fuelTypes: [] as string[],
    colors: [] as string[]
  });

  // Load images from IndexedDB on mount
  useEffect(() => {
    async function loadImages() {
      try {
        const savedCars = await loadFromIndexedDB('car-inventory-images');
        
        if (savedCars && Array.isArray(savedCars)) {
          console.log('Loaded cars from IndexedDB:', savedCars);
          
          // Merge saved images with default vehicles
          const updatedVehicles = allVehicles.map(vehicle => {
            const savedCar = savedCars.find((c: any) => c.id === vehicle.id);
            if (savedCar && savedCar.images && savedCar.images.length > 0) {
              // Extract URLs from saved images - handle both string and object formats
              const imageUrls = savedCar.images
                .map((img: any) => {
                  if (typeof img === 'string') return img;
                  if (img && typeof img === 'object' && img.url) return img.url;
                  return null;
                })
                .filter((url: string | null) => url !== null);
              
              console.log(`Updated vehicle ${vehicle.id} with ${imageUrls.length} images`);
              
              if (imageUrls.length > 0) {
                return {
                  ...vehicle,
                  images: imageUrls
                };
              }
            }
            return vehicle;
          });
          
          setVehicles(updatedVehicles);
          setFilteredVehicles(updatedVehicles);
        }
      } catch (error) {
        console.error('Error loading images from IndexedDB:', error);
        // Continue with default images if loading fails
      }
    }
    
    loadImages();

    // Listen for updates from admin panel
    const handleInventoryUpdate = () => {
      console.log('Inventory update detected, reloading images...');
      loadImages();
    };

    const handleVehiclesUpdate = () => {
      console.log('Vehicles update detected, reloading...');
      loadImages();
    };

    window.addEventListener('inventoryImagesUpdated', handleInventoryUpdate);
    window.addEventListener('vehiclesUpdated', handleVehiclesUpdate);

    return () => {
      window.removeEventListener('inventoryImagesUpdated', handleInventoryUpdate);
      window.removeEventListener('vehiclesUpdated', handleVehiclesUpdate);
    };
  }, []);

  useEffect(() => {
    const savedVehicles = localStorage.getItem('vehicles');
    if (savedVehicles) {
      const parsedVehicles = JSON.parse(savedVehicles);
      // Merge with any IndexedDB images
      async function mergeWithImages() {
        try {
          const savedCars = await loadFromIndexedDB('car-inventory-images');
          if (savedCars && Array.isArray(savedCars)) {
            const updatedVehicles = parsedVehicles.map((vehicle: Vehicle) => {
              const savedCar = savedCars.find((c: any) => c.id === vehicle.id);
              if (savedCar && savedCar.images && savedCar.images.length > 0) {
                const imageUrls = savedCar.images
                  .map((img: any) => {
                    if (typeof img === 'string') return img;
                    if (img && typeof img === 'object' && img.url) return img.url;
                    return null;
                  })
                  .filter((url: string | null) => url !== null);
                
                if (imageUrls.length > 0) {
                  return {
                    ...vehicle,
                    images: imageUrls
                  };
                }
              }
              return vehicle;
            });
            setVehicles(updatedVehicles);
          } else {
            setVehicles(parsedVehicles);
          }
        } catch (error) {
          console.error('Error merging images:', error);
          setVehicles(parsedVehicles);
        }
      }
      mergeWithImages();
    }
  }, []);

  // Listen for vehicle updates from admin panel
  useEffect(() => {
    const handleVehiclesUpdate = async () => {
      console.log('Vehicle update event received');
      
      // Reload from IndexedDB
      try {
        const savedCars = await loadFromIndexedDB('car-inventory-images');
        
        if (savedCars && Array.isArray(savedCars)) {
          console.log('Reloading vehicles with updated images');
          
          const savedVehicles = localStorage.getItem('vehicles');
          const baseVehicles = savedVehicles ? JSON.parse(savedVehicles) : allVehicles;
          
          const updatedVehicles = baseVehicles.map((vehicle: Vehicle) => {
            const savedCar = savedCars.find((c: any) => c.id === vehicle.id);
            if (savedCar && savedCar.images && savedCar.images.length > 0) {
              const imageUrls = savedCar.images
                .map((img: any) => {
                  if (typeof img === 'string') return img;
                  if (img && typeof img === 'object' && img.url) return img.url;
                  return null;
                })
                .filter((url: string | null) => url !== null);
              
              if (imageUrls.length > 0) {
                return {
                  ...vehicle,
                  images: imageUrls
                };
              }
            }
            return vehicle;
          });
          
          setVehicles(updatedVehicles);
        }
      } catch (error) {
        console.error('Error loading updated images:', error);
      }
    };

    window.addEventListener('vehiclesUpdated', handleVehiclesUpdate);
    return () => window.removeEventListener('vehiclesUpdated', handleVehiclesUpdate);
  }, []);

  // Apply URL parameters on initial load
  useEffect(() => {
    const make = searchParams.get('make');
    const price = searchParams.get('price');
    const year = searchParams.get('year');
    const bodyType = searchParams.get('bodyType');

    const newFilters = { ...filters };
    let hasChanges = false;

    if (make) {
      newFilters.makes = [make];
      hasChanges = true;
    }

    if (price) {
      const [min, max] = price.split('-').map(p => parseInt(p) || 50000);
      newFilters.priceRange = [min, max];
      hasChanges = true;
    }

    if (year) {
      const yearNum = parseInt(year);
      newFilters.yearRange = [yearNum, yearNum];
      hasChanges = true;
    }

    if (bodyType) {
      newFilters.bodyTypes = [bodyType];
      hasChanges = true;
    }

    if (hasChanges) {
      setFilters(newFilters);
    }
  }, [searchParams]);

  useEffect(() => {
    let filtered = [...vehicles];

    // Apply search query
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(vehicle => {
        return (
          vehicle.name.toLowerCase().includes(query) ||
          vehicle.make.toLowerCase().includes(query) ||
          vehicle.model.toLowerCase().includes(query) ||
          vehicle.year.toString().includes(query) ||
          vehicle.bodyType.toLowerCase().includes(query) ||
          vehicle.transmission.toLowerCase().includes(query) ||
          vehicle.fuelType.toLowerCase().includes(query) ||
          vehicle.color.toLowerCase().includes(query)
        );
      });
    }

    // Apply filters
    filtered = filtered.filter(vehicle => {
      const priceMatch = vehicle.price >= filters.priceRange[0] && vehicle.price <= filters.priceRange[1];
      const mileageMatch = vehicle.mileage >= filters.mileageRange[0] && vehicle.mileage <= filters.mileageRange[1];
      const yearMatch = vehicle.year >= filters.yearRange[0] && vehicle.year <= filters.yearRange[1];
      const makeMatch = filters.makes.length === 0 || filters.makes.includes(vehicle.make);
      const modelMatch = filters.models.length === 0 || filters.models.includes(vehicle.model);
      const bodyTypeMatch = filters.bodyTypes.length === 0 || filters.bodyTypes.includes(vehicle.bodyType);
      const transmissionMatch = filters.transmissions.length === 0 || filters.transmissions.includes(vehicle.transmission);
      const fuelTypeMatch = filters.fuelTypes.length === 0 || filters.fuelTypes.includes(vehicle.fuelType);
      const colorMatch = filters.colors.length === 0 || filters.colors.includes(vehicle.color);

      return priceMatch && mileageMatch && yearMatch && makeMatch && modelMatch && 
             bodyTypeMatch && transmissionMatch && fuelTypeMatch && colorMatch;
    });

    // Apply sorting
    switch (sortBy) {
      case 'price-low':
        filtered.sort((a, b) => a.price - b.price);
        break;
      case 'price-high':
        filtered.sort((a, b) => b.price - a.price);
        break;
      case 'mileage-low':
        filtered.sort((a, b) => a.mileage - b.mileage);
        break;
      case 'year-new':
        filtered.sort((a, b) => b.year - a.year);
        break;
      case 'year-old':
        filtered.sort((a, b) => a.year - b.year);
        break;
      default:
        // Featured - keep original order
        break;
    }

    setFilteredVehicles(filtered);
  }, [filters, vehicles, sortBy, searchQuery]);

  const handleCompare = () => {
    const vehiclesToCompare = vehicles.filter(car => selectedForCompare.includes(car.id));
    navigate('/compare', { state: { vehicles: vehiclesToCompare } });
  };

  const resetFilters = () => {
    setFilters({
      priceRange: [0, 50000],
      mileageRange: [0, 150000],
      yearRange: [2015, 2024],
      makes: [],
      models: [],
      bodyTypes: [],
      transmissions: [],
      fuelTypes: [],
      colors: []
    });
    setSearchQuery('');
    // Clear URL parameters
    navigate('/inventory', { replace: true });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Browse Our Inventory</h1>
          <p className="text-gray-600 text-sm sm:text-base">Find your perfect vehicle from our selection of quality pre-owned cars</p>
        </div>

        {/* Search Bar */}
        <div className="mb-6">
          <div className="relative w-full">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <i className="ri-search-line text-xl text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by make, model, year, body type, or color..."
              className="w-full pl-12 pr-12 py-4 bg-[#F8F9FA] border-2 border-transparent rounded-2xl text-sm focus:outline-none focus:border-[#E85D26] focus:bg-white transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery('')}
                className="absolute inset-y-0 right-0 pr-4 flex items-center cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-400 hover:text-gray-600"></i>
              </button>
            )}
          </div>
        </div>

        {/* Filter Toggle Button */}
        <div className="mb-4">
          <button
            onClick={() => setShowFilters(prev => !prev)}
            className="flex items-center gap-2 px-5 py-2.5 bg-gray-900 text-white rounded-xl text-sm font-semibold hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className={`ri-filter-3-line text-base`}></i>
            {showFilters ? 'Hide Filters' : 'Show Filters'}
            <i className={`ri-arrow-${showFilters ? 'up' : 'down'}-s-line text-base`}></i>
          </button>
        </div>

        {/* Filter Sidebar - Collapsible */}
        {showFilters && (
          <FilterSidebar 
            filters={filters}
            setFilters={setFilters}
            vehicles={vehicles}
            resetFilters={resetFilters}
          />
        )}

        {/* Toolbar */}
        <div className="bg-[#F8F9FA] rounded-2xl p-4 mb-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-4 flex-wrap">
            <p className="text-sm text-gray-600">
              <strong className="text-gray-900">{filteredVehicles.length}</strong> vehicles found
            </p>
            {selectedForCompare.length > 0 && (
              <button
                onClick={handleCompare}
                className="px-4 py-2 bg-[#E85D26] text-white rounded-full text-sm font-medium hover:bg-[#d14e1f] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-scales-line"></i>
                Compare ({selectedForCompare.length})
              </button>
            )}
          </div>

          <div className="flex items-center gap-3 w-full sm:w-auto">
            <label className="text-sm text-gray-600 whitespace-nowrap">Sort by:</label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="flex-1 sm:flex-none px-4 py-2 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-900 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#E85D26]"
            >
              <option value="featured">Featured</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="mileage-low">Mileage: Low to High</option>
              <option value="year-new">Year: Newest First</option>
              <option value="year-old">Year: Oldest First</option>
            </select>
          </div>
        </div>

        {/* Vehicle Grid */}
        <VehicleGrid 
          vehicles={filteredVehicles}
          selectedForCompare={selectedForCompare}
          setSelectedForCompare={setSelectedForCompare}
        />
      </div>

      <Footer />
    </div>
  );
}
